<template>
  <el-dialog
    :title="type === 'update' ? '编辑账号' : '新增账号'"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="95px">
      <el-form-item
        label="账号："
        prop="account">
        {{ info.account }}
      </el-form-item>
      <el-form-item
        label="姓名："
        prop="staffName">
        {{ info.staffName }}
      </el-form-item>
      <el-form-item
        label="手机号："
        prop="mobile">
        {{ info.mobile }}
      </el-form-item>
      <el-form-item
        label="仓库范围："
        prop="warehousePermissions">
        <warehouse-checkbox
          v-model="info.warehousePermissions" />
      </el-form-item>
      <el-form-item
        label="部门范围："
        prop="departmentPermissions">
        <department-checkbox
          v-model="info.departmentPermissions" />
      </el-form-item>
      <el-form-item
        label="功能权限："
        prop="functions">
        <checkbox-tree
          ref="tree"
          v-model="info.functions"
          :treeData="menuNodes"
          nodeKey="funcId"
          :defaultProps="defaultProps" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
    <vendor-series-checkbox
      v-show="false"
      ref="series"
      v-model="info.productLinePermmisions"
      :option="{vendorId: userInfo.orgId}" />
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import CheckboxTree from './checkbox-tree.vue'

import { guid } from '@/utils/index'
import VendorSeriesCheckbox from '../../../components/business/vendor-series-checkbox.vue'
import WarehouseCheckbox from './warehouse-checkbox.vue'
import DepartmentCheckbox from './department-checkbox.vue'

export default {
  name: 'EditStaffModal',
  components: { CheckboxTree, VendorSeriesCheckbox, WarehouseCheckbox, DepartmentCheckbox },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      menuNodes: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      info: {
        account: '',
        staffName: '',
        mobile: '',
        departmentPermissions: [],
        warehousePermissions: [],
        productLinePermmisions: [],
        functions: []
      },
      type: 'add',
      rules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        staffName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        productLinePermmisions: [
          { required: true, message: '业务范围不能为空', trigger: 'change' }
        ],
        departmentPermissions: [
          { required: false, message: '业务的部门范围不能为空', trigger: 'change' }
        ],
        warehousePermissions: [
          { required: false, message: '业务的仓库范围不能为空', trigger: 'change' }
        ],
        functions: [
          { required: true, message: '功能权限不能为空', trigger: 'change' }
        ]
        // mobile: [
        //   {
        //     required: true,
        //     message: '手机号不能为空',
        //     trigger: 'blur'
        //   },
        //   {
        //     pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
        //     message: '请输入正确的手机号',
        //     trigger: 'blur'
        //   }
        // ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.info = {
        account: '',
        staffName: '',
        mobile: '',
        departmentPermissions: [],
        warehousePermissions: [],
        productLinePermmisions: [],
        functions: []
      }
    },
    handleSubmit() {
      console.log(this.$refs.series)
      const CheckedNodes = this.$refs.tree.getCheckedNodes().filter(s => typeof s.funcId === 'number')
      console.log(CheckedNodes)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.type === 'update' ? 'updatestaff' : 'addstaff'
          // this.type === 'update' ? (this.userPermission.ENT_ADMIN ? 'updatestaff' : 'updateme') : 'addstaff'
          this.$store.dispatch(`staff/${dispatch}`, {
            payload: {
              ...this.info,
              userType: 100,
              password: '123456',
              functions: CheckedNodes.map(item => {
                return {
                  funcId: item.funcId,
                  operations: item.checkedList ? item.checkedList.map(s => ({ operation: s })) : null
                }
              }),
              // productLinePermmisions: this.info.productLinePermmisions.map(item => ({ productLineNo: item })),
              departmentPermissions: this.info.departmentPermissions.map(item => ({ departmentId: item })),
              warehousePermissions: this.info.warehousePermissions.map(item => ({ warehouseId: item })),
              productLinePermmisions: this.$refs.series.list.map(i => ({ productLineNo: i.productLineNo })),
              email: '111.@qq.com'
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getportalmenutree2orgtype() {
      this.loading = true
      this.$store.dispatch('staff/getorgportalmenutree', {
        payload: {
          orgType: 100
        },
        success: res => {
          this.loading = false
          // const menuNodes = []
          // res.data.menuNodes.forEach(i => {
          //   menuNodes.push(...i.children)
          // })
          // this.menuNodes = menuNodes
          res.data.menuNodes.forEach(item => {
            if (!item.funcId) {
              item.funcId = `custom-${guid()}`
            }
          })
          this.menuNodes = res.data.menuNodes.map(i => {
            // const disabled = this.info.isAdmin === 1
            // i.disabled = disabled
            i.children = i.children ? i.children.map(s => {
              // s.disabled = disabled
              // if (s.funcId === 100) {
              const item = this.info.functionsBak.find(m => m.funcId === s.funcId) || {}
              s.checkedList = (item.operations || []).map(m => m.operation)
              // }
              return s
            }) : []
            return i
          })
        },
        fail: () => {
          this.loading = false
          this.menuNodes = []
        }
      })
    },
    init(options = {}, type) {
      this.info = {
        ...this.info,
        ...options
      }
      this.type = type
      // if (this.userPermission.ENT_ADMIN) {
      //   this.getportalmenutree2orgtype()
      // }
      this.getportalmenutree2orgtype()
      this.toggleModal(true)
    }
  }
}
</script>
